import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from "../../api";
import { formatStaticDealsParams } from "../../utilities/helpers";
import { getParamFromUrl } from "../../utilities/urlResolver";

const initialState = {
  hotels: [],
  selectedHotel: {
    hotelId: getParamFromUrl('hotelId') || getParamFromUrl('pr_hotelId'),
    hfHotelId: getParamFromUrl('hfHotelId'),
  },
  staticDeal: {},
  state: 'idle',
  showLoader: false,
};

export const fetchHotelsByName = createAsyncThunk(
  'fetchHotelsByName',
  async ({ name, destinationIds }) => {
    const response = await api.fetchHotelsByName(name, destinationIds);

    return response.data;
  }
)

export const fetchHotelById = createAsyncThunk(
  'fetchHotelById',
  async ({ id, destinationIds }) => {
    const response = await api.fetchHotelById(id, destinationIds);

    return response.data;
  }
)

export const fetchStaticHotelById = createAsyncThunk(
  'fetchStaticHotelById',
  async ({ id, destination }, thunkAPI) => {
    const { secondaryFilter, mainFilter } = thunkAPI.getState();
    const [selectedDestination] = mainFilter.searchEngine.where?.destinations?.filter(
      ({ active }) => active
    ) || [];

    const response = await api.fetchLocationDealsList({
      ...formatStaticDealsParams({
        filters: {
          ...secondaryFilter.data,
          providerHotelIds: [id],
        },
        destination: destination || selectedDestination.id,
      }),
      page: 1,
      offset: 0,
    });

    return response.hotels[0];
  }
)

export const searchSlice = createSlice({
  name: 'userSearch',
  initialState,
  reducers: {
    setSelectedHotel: (state, action) => {
      state.selectedHotel = action.payload;
    },
    clearSelectedHotel: (state) => {
      return {
        ...state,
        selectedHotel: {},
        staticDeal: {},
      };
    },
    clearSearch: (state) => {
      state.selectedHotel = {};
      state.staticDeal = {};
      state.hotels = [];
    },
    clearStaticDeal:  (state) => {
      state.staticDeal = {};
    },
    setShowLoader: (state, action) => {
      state.showLoader = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHotelsByName.pending, (state) => {
        state.state = 'loading';
      })
      .addCase(fetchHotelsByName.fulfilled, (state, action) => {
        state.hotels = action.payload;
        state.state = 'loaded';
      })
      .addCase(fetchHotelsByName.rejected, (state) => {
        state.state = 'failed';
      })
      .addCase(fetchHotelById.fulfilled, (state, action) => {
        state.hotels = [...action.payload];
        if (action.payload.length) {
          state.selectedHotel = {...action.payload[0]};
        }
      })
      .addCase(fetchStaticHotelById.pending, (state) => {
        state.showLoader = true;
      })
      .addCase(fetchStaticHotelById.fulfilled, (state, action) => {
        state.staticDeal = action.payload;
        state.showLoader = false;
      })
      .addCase(fetchStaticHotelById.rejected, (state) => {
        state.showLoader = false;
      })
  }
})

export const {
  setSelectedHotel,
  clearSelectedHotel,
  clearSearch,
  clearStaticDeal,
  setShowLoader,
} = searchSlice.actions;

export default searchSlice.reducer;
